module.exports = __webpack_public_path__ + "img/active.6212b8cc.svg";